import { migrationCanvasSelectors } from '@store/migrationSelectors/canvasSelectors'
import { useSelector } from 'react-redux'

export const useScaleZoom = () => {
  const scale = useSelector(migrationCanvasSelectors.getScale)
  const zoom = Math.round(scale * 100)

  return {
    scale,
    zoom,
  }
}
